import React, { FunctionComponent } from "react";
import { useRecoilValue } from "recoil";
import { BlueDivision, DownIcon, Equal, Plus, Telegram } from "../../../../assets/Icons";
import { offlineSBM } from "../../../../store";
import IReviewPage from "./ReviewPage";

export const Calculation: FunctionComponent<IReviewPage.CalculationProps> = ({
  taxStep,
  setTaxStep,
}) => {
  const offlineSbmData: any = useRecoilValue(offlineSBM);
  const totalTaxes =
    offlineSbmData.total_tax +
    offlineSbmData.nostro_charges +
    offlineSbmData.nostro_charges_new +
    offlineSbmData.hop_fees +
    offlineSbmData.tcs;
  return (
    <div className="w-[350px] ml-16">
      <div className="mb-10 font-bold font-ssp text-black -ml-28 text-md text-[16px]">
        Calculation
      </div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex flex-col flex-1 -ml-28">
          <div className="flex items-center justify-between mb-0">
            <div className="flex items-center space-x-2 text-xs font-bold text-black lg:text-base">
              <div className="mr-3 rotate-180">
                <DownIcon fillColor="rotate-90" />
              </div>
              You Send
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-bold text-black lg:text-base">
                {offlineSbmData.user_send}
              </div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="bg-grey-1350 w-[30px] h-[30px] rounded-full flex justify-center items-center -ml-28">
          <BlueDivision />
        </div>
        <div className="flex items-center justify-between flex-1 ml-5">
          <div className="-ml-2 text-xs font-bold text-black lg:text-base">Exchange rate</div>
          <div className="flex items-center justify-between space-x-16">
            <div className="text-xs font-bold lg:text-base">{offlineSbmData?.conversion_rate}</div>
            <div className="text-xs font-bold lg:text-base">INR</div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-8">
        <div className="flex flex-col flex-1 -ml-28">
          <div
            onClick={() => setTaxStep(!taxStep)}
            className="flex items-center justify-between cursor-pointer hover:underline"
          >
            <div className="flex items-center text-xs font-bold text-black lg:text-base">
              <div className="mr-3">
                {taxStep === true ? <DownIcon fillColor="rotate-180" /> : <DownIcon />}
              </div>
              Taxes and fees
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-bold text-black lg:text-base">
                {totalTaxes.toFixed(2)}
              </div>
              <div className="text-xs font-bold text-black lg:text-base">INR</div>
            </div>
          </div>
          {taxStep === true && (
            <div className="mt-4 ml-[5px] animate-fade duration-0">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  GST
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-bold text-black lg:text-base">
                    {offlineSbmData?.total_tax}
                  </div>
                  <div className="text-xs font-bold text-black lg:text-base">INR</div>
                </div>
              </div>
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  Bank Fee
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {offlineSbmData?.nostro_charges}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between space-x-5">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  <span>NOSTRO</span>
                  <div className="flex ml-20">
                    <div className="px-2 text-white rounded bg-primary-1050">
                      {offlineSbmData.isBene === null ? "Our" : "Bene"}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {offlineSbmData?.nostro_charges_new}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[12px]">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  Vendor Fee
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {offlineSbmData?.hop_fees}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mt-[12px]">
                <div className="flex items-center text-xs font-normal text-black lg:text-base">
                  <div className="mr-3">
                    <Plus fillColor="#B9C9DF" />
                  </div>
                  TCS
                </div>
                <div className="flex items-center justify-between space-x-16">
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    {offlineSbmData?.tcs ? offlineSbmData.tcs : 0}
                  </div>
                  <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                    INR
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="mt-4 border border-gray-500 rounded-full"></div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <Equal />
              </div>
              <span className="font-bold text-black">You Pay</span>
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {offlineSbmData?.total_pay}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">INR</div>
            </div>
          </div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center text-xs font-normal text-black lg:text-base">
              <div className="mr-3">
                <Telegram />
              </div>
              <span className="font-bold text-black">They Receive</span>
            </div>
            <div className="flex items-center justify-between space-x-16">
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {offlineSbmData?.reciepient_recieve}
              </div>
              <div className="text-xs font-normal text-black lg:font-bold lg:text-base">
                {offlineSbmData.dest_currency}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
